import { isAuthenticated, useAuth } from '@suntex.fim/auth/react';
import { LoginType } from '@suntex.fim/enums';

import { usePlayer } from '../hooks';
import '../style/PlayerDashboard.scss';

import { DashboardMain } from './DashboardMain';
import { PlayerSidebar } from './DashboardSidebar';

export function PlayerDashboard() {
  const { isPreview } = usePlayer();
  const { login } = useAuth(isAuthenticated);
  const isTeamLeader = login.loginType === LoginType.TeamLeader;

  return (
    <div className="player-dashboard">
      <div className="player-dashboard__main">
        <DashboardMain />
      </div>
      {!isPreview && (
        <aside
          className="player-dashboard__sidebar"
          aria-label="Player dashboard sidebar"
        >
          <PlayerSidebar
            noneUserRoute={
              isTeamLeader
                ? (teamId, userId) =>
                    `/team/${teamId}/team-management/team-roster?noneUserId=${userId}`
                : undefined
            }
          />
        </aside>
      )}
    </div>
  );
}
